import api from "../config/api";

export const getAllWagons = async () => {
  const res = await api.get("/wagon/");
  return res.data;
};

export const getWagonById = async (id) => {
  const res = await api.get(`/wagon/?id=${id}`);
  return res.data;
};

export const getWagonByFilter = async ({
  from_date = "",
  to_date = "",
  station = "",
}) => {
  try {
    const params = new URLSearchParams();
    if (from_date) params.append("from_date", from_date);
    if (to_date) params.append("to_date", to_date);
    if (station) params.append("station", station);
    const res = await api.get(`/wagon/?${params.toString()}`);
    return res.data;
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const saveWagon = async (data) => {
  const res = await api.post("/wagon/", data, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const updateWagon = async (data) => {
  const res = await api.put("/wagon/", data, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const deleteWagon = async (id) => {
  const res = await api.delete(`/wagon/?id=${id}`);
  return res.data;
};
